module.exports = __webpack_public_path__ + "static/media/ic_reservation_lunch.204c9213.svg";